import { render, staticRenderFns } from "./AppBarItemMenu.vue?vue&type=template&id=0812f3cc"
import script from "./AppBarItemMenu.vue?vue&type=script&lang=js"
export * from "./AppBarItemMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports